import * as auth from 'js/action/auth'
import * as dashboard from 'js/action/dashboard'
import * as explorer from 'js/action/explorer'
import * as map from 'js/action/map'
import * as notes from 'js/action/notes'
import * as report from 'js/action/report'
import * as search from 'js/action/search'
import * as general from 'js/action/general'
import { applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import history from 'js/redux/middleware/history'

export const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default composeEnhancers(
  applyMiddleware(
    history,
    thunkMiddleware.withExtraArgument({
      auth,
      dashboard,
      explorer,
      map,
      notes,
      report,
      search,
      general
    })
  )
)
